import { FamilyStepsEnum } from '@pages/hubs/Family/enum/family-steps-enum';

export const createFamilyFormStepper = [
  FamilyStepsEnum.preStepFamilyType,
  FamilyStepsEnum.generalBase,
  FamilyStepsEnum.generalSecond,
  FamilyStepsEnum.childBodyParameters,
  FamilyStepsEnum.childHairColor,
  FamilyStepsEnum.childEyeColor,
  FamilyStepsEnum.childBodyArtTypes,
  FamilyStepsEnum.share,
  FamilyStepsEnum.congratulations,
];

export const familyFormStepper = {
  [FamilyStepsEnum.preStepFamilyType]: {
    stepId: FamilyStepsEnum.preStepFamilyType,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 0,
  },
  [FamilyStepsEnum.generalBase]: {
    stepId: FamilyStepsEnum.generalBase,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 1,
  },
  [FamilyStepsEnum.generalSecond]: {
    stepId: FamilyStepsEnum.generalSecond,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 2,
  },
  [FamilyStepsEnum.childBodyParameters]: {
    stepId: FamilyStepsEnum.childBodyParameters,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 3,
  },
  [FamilyStepsEnum.childHairColor]: {
    stepId: FamilyStepsEnum.childHairColor,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 4,
  },
  [FamilyStepsEnum.childEyeColor]: {
    stepId: FamilyStepsEnum.childEyeColor,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 5,
  },
  [FamilyStepsEnum.childBodyArtTypes]: {
    stepId: FamilyStepsEnum.childBodyArtTypes,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 6,
  },
  [FamilyStepsEnum.share]: {
    stepId: FamilyStepsEnum.share,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 7,
  },
  [FamilyStepsEnum.congratulations]: {
    stepId: FamilyStepsEnum.congratulations,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 8,
  },
};
